"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ["AZ", "CA", "ID", "LA", "NV", "NM", "PR", "TX", "WA", "WI"];